if (!customElements.get('hot-sand-dish-bundle')) {
  customElements.define(
    'hot-sand-dish-bundle',
    class HotSandDishBundle extends HTMLElement {
      connectedCallback() {
        this.colorOptions = Array.from(this.querySelectorAll('[data-hsd-color]'));
        this.mainQuantity = this.querySelector('[data-hsd-main-quantity]');
        this.caseToggle = this.querySelector('[data-hsd-case-toggle]');
        this.caseQuantity = this.querySelector('[data-hsd-case-quantity]');
        this.caseCard = this.querySelector('[data-hsd-case-card]');
        this.selectedColor = this.querySelector('[data-hsd-selected-color]');
        this.total = this.querySelector('[data-hsd-total]');
        this.submitButton = this.querySelector('[data-hsd-submit]');
        this.status = this.querySelector('[data-hsd-status]');
        this.currency = this.dataset.currency || 'JPY';

        this.colorOptions.forEach((option) => {
          option.addEventListener('change', () => this.update());
        });
        this.mainQuantity?.addEventListener('input', () => this.update());
        this.caseToggle?.addEventListener('change', () => {
          if (this.caseQuantity) this.caseQuantity.disabled = !this.caseToggle.checked;
          this.caseCard?.classList.toggle('is-selected', this.caseToggle.checked);
          this.update();
        });
        this.caseQuantity?.addEventListener('input', () => this.update());
        this.submitButton?.addEventListener('click', () => this.addToCart());
        this.update();
      }

      getSelectedColor() {
        return this.colorOptions.find((option) => option.checked && !option.disabled) || null;
      }

      getItems() {
        const color = this.getSelectedColor();
        if (!color) return [];

        const items = [{
          id: Number(color.value),
          quantity: Math.max(1, Number(this.mainQuantity?.value) || 1),
        }];

        if (this.caseToggle?.checked && !this.caseToggle.disabled) {
          items.push({
            id: Number(this.caseToggle.value),
            quantity: Math.max(1, Number(this.caseQuantity?.value) || 1),
          });
        }
        return items;
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: this.currency,
            maximumFractionDigits: this.currency === 'JPY' ? 0 : 2,
          }).format(cents / 100);
        } catch (error) {
          return `${Math.round(cents / 100).toLocaleString('ja-JP')}円`;
        }
      }

      update() {
        const color = this.getSelectedColor();
        this.colorOptions.forEach((option) => {
          option.closest('.hsd-color-card')?.classList.toggle('is-selected', option === color);
        });

        if (!color) {
          if (this.selectedColor) this.selectedColor.textContent = 'カラーを選択';
          if (this.total) this.total.textContent = '—';
          return;
        }

        if (this.selectedColor) this.selectedColor.textContent = color.dataset.colorName || '';
        let total = (Number(color.dataset.price) || 0) * Math.max(1, Number(this.mainQuantity?.value) || 1);
        if (this.caseToggle?.checked) {
          total += (Number(this.caseToggle.dataset.price) || 0) * Math.max(1, Number(this.caseQuantity?.value) || 1);
        }
        if (this.total) this.total.textContent = this.formatMoney(total);
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }

      async addToCart() {
        const items = this.getItems();
        if (!items.length) {
          this.setStatus('本体カラーを選択してください。', true);
          return;
        }

        const cartNotification = document.querySelector('cart-notification');
        const sections = cartNotification?.getSectionsToRender().map((section) => section.id) || [];
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';

        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.setStatus('カートに追加しています…');

        try {
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'カートに追加できませんでした。');
          }

          this.setStatus(`${items.length}点をカートに追加しました。`);
          if (cartNotification && result.sections) {
            cartNotification.setActiveElement?.(this.submitButton);
            cartNotification.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          this.setStatus(error.message || 'カートに追加できませんでした。時間をおいて再度お試しください。', true);
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.disabled = false;
        }
      }
    }
  );
}
